var $f257504b02c6b23f$exports = {};
$f257504b02c6b23f$exports = {
  "pending": `f\xfcgg\u{151}ben lev\u{151}`
};
export { $f257504b02c6b23f$exports as default };